import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useAgentLibraryLdFlags = createFlagsHook<typeof import('./flags.json')>()
